import { ThreeDots } from 'platform-components';
import React, { useCallback } from 'react';

import { SidePanelControlsItemProps } from './typings';

export const SidePanelControlsItem = ({
    render,
    name,
    withBorder,
    shouldShowItem,
    addRenderControl,
    removeRenderControl,
}: SidePanelControlsItemProps) => {
    const notifyCanBeRender = useCallback(() => {
        addRenderControl(name);
    }, [addRenderControl, name]);
    const notifyCanNotBeRender = useCallback(() => {
        removeRenderControl(name);
    }, [name, removeRenderControl]);

    const element = render({
        notifyCanBeRender,
        notifyCanNotBeRender,
    });

    if (!shouldShowItem) {
        return <>{element}</>;
    }

    return (
        <ThreeDots.Item type={ThreeDots.TYPES.PLAIN} withBorder={withBorder}>
            {element}
        </ThreeDots.Item>
    );
};
